import type { AuthUser } from "@models/quota";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  user: AuthUser | null;
}

interface AuthActions {
  setUser: (user: AuthUser | null) => void;
  clearAuth: () => void;
}

// `isAuthenticated` is derived state — every production caller reads
// `user !== null` directly (see `router.tsx` `beforeLoad`). Subscribe with
// `useAuthStore((s) => s.user !== null)` if you need a boolean.
export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      clearAuth: () => set({ user: null }),
    }),
    { name: "circuit-forge-auth" },
  ),
);
